import { Percent } from '../../../../../../domain/Percent';
import { AttentionStatus } from '../../../../../AttentionStatus';
import { EvaluationResult } from '../../../../../EvaluatedResult';
import type { EvaluationResultType } from '../../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../../RulesProvider';

export class VoltageDiffTransformerEndPercentEvaluation {
  private readonly ruleName =
    'Lv_EnergyConsumer_VoltageDiffTransformerEndPercent';

  constructor(private readonly rulesProvider: ForRuleProviding) {}

  public evaluate(voltageDiffPercent: number): EvaluationResultType<Percent> {
    const rule = this.rulesProvider.getRule(this.ruleName);
    const status = AttentionStatus.fromAlertScale(
      rule?.value,
      voltageDiffPercent
    );
    const value = Percent.fromFloat(voltageDiffPercent);
    return EvaluationResult.from(status, value, this.ruleName);
  }
}
